// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cpm-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: var(--cpm-width, 480px);
  height: var(--cpm-height, auto);
  max-height: var(--cpm-max-height, 80vh);
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 12px;
  outline: none;
  overflow: visible;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}

.cpm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
  border-radius: 12px 12px 0 0;
  background: #ffffff;
}

.cpm-title {
  font-size: 15px;
  font-weight: 600;
  color: #0b0b0b;
  line-height: 1.3;
}

.cpm-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  color: #6b6b6b;
  padding: 4px;
  border-radius: 6px;
  line-height: 0;
  transition: background 0.15s, color 0.15s;
}

.cpm-close-btn:hover {
  background: #f5f5f5;
  color: #0b0b0b;
}

.cpm-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.cpm-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid #f0f0f0;
  flex-shrink: 0;
  border-radius: 0 0 12px 12px;
  background: #ffffff;
}

/* ═══ DARK THEME — CustomPopupModal ═══ */
.dark .cpm-overlay {
  background: #1e293b;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
}
.dark .cpm-header {
  background: #1e293b;
  border-bottom-color: #334155;
}
.dark .cpm-title { color: #f1f5f9; }
.dark .cpm-close-btn { color: #94a3b8; }
.dark .cpm-close-btn:hover { background: #334155; color: #e2e8f0; }
.dark .cpm-footer {
  background: #1e293b;
  border-top-color: #334155;
}
`, "",{"version":3,"sources":["webpack://./client/src/customComponents/CustomPopupModal/CustomPopupModal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;EAC/B,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;AACA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,mBAAmB,cAAc,EAAE;AACnC,uBAAuB,cAAc,EAAE;AACvC,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;AAClE;EACE,mBAAmB;EACnB,yBAAyB;AAC3B","sourcesContent":[".cpm-overlay {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: var(--cpm-width, 480px);\n  height: var(--cpm-height, auto);\n  max-height: var(--cpm-max-height, 80vh);\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  border-radius: 12px;\n  outline: none;\n  overflow: visible;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n}\n\n.cpm-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #f0f0f0;\n  flex-shrink: 0;\n  border-radius: 12px 12px 0 0;\n  background: #ffffff;\n}\n\n.cpm-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: #0b0b0b;\n  line-height: 1.3;\n}\n\n.cpm-close-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #6b6b6b;\n  padding: 4px;\n  border-radius: 6px;\n  line-height: 0;\n  transition: background 0.15s, color 0.15s;\n}\n\n.cpm-close-btn:hover {\n  background: #f5f5f5;\n  color: #0b0b0b;\n}\n\n.cpm-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.cpm-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 20px;\n  border-top: 1px solid #f0f0f0;\n  flex-shrink: 0;\n  border-radius: 0 0 12px 12px;\n  background: #ffffff;\n}\n\n/* ═══ DARK THEME — CustomPopupModal ═══ */\n.dark .cpm-overlay {\n  background: #1e293b;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n}\n.dark .cpm-header {\n  background: #1e293b;\n  border-bottom-color: #334155;\n}\n.dark .cpm-title { color: #f1f5f9; }\n.dark .cpm-close-btn { color: #94a3b8; }\n.dark .cpm-close-btn:hover { background: #334155; color: #e2e8f0; }\n.dark .cpm-footer {\n  background: #1e293b;\n  border-top-color: #334155;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
